export default {
  buttons: {
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    update: "تحديث",
    submit: "إرسال",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    search: "بحث",
    filter: "تصفية",
    reset: "إعادة تعيين",
    clear: "مسح",
    confirm: "تأكيد",
    yes: "نعم",
    no: "لا",
    ok: "موافق",
    apply: "تطبيق",
    export: "تصدير",
    import: "استيراد",
    download: "تحميل",
    upload: "رفع",
    view: "عرض",
    details: "التفاصيل",
    select: "اختيار",
    selectAll: "تحديد الكل",
    deselectAll: "إلغاء تحديد الكل",
    refresh: "تحديث",
    loading: "جاري التحميل...",
    processing: "جاري المعالجة...",
  },
  messages: {
    success: "تمت العملية بنجاح",
    error: "حدث خطأ",
    warning: "تحذير",
    info: "معلومة",
    confirmDelete: "هل أنت متأكد من حذف هذا العنصر؟",
    confirmAction: "هل أنت متأكد من تنفيذ هذا الإجراء؟",
    noData: "لا توجد بيانات متاحة",
    noResults: "لم يتم العثور على نتائج",
    loading: "جاري التحميل...",
    saving: "جاري الحفظ...",
    saved: "تم الحفظ بنجاح",
    updated: "تم التحديث بنجاح",
    deleted: "تم الحذف بنجاح",
    created: "تم الإنشاء بنجاح",
    errorOccurred: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك.",
    unauthorized: "غير مصرح لك بتنفيذ هذا الإجراء",
    forbidden: "الوصول محظور",
    notFound: "المورد غير موجود",
    serverError: "خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
  },
  labels: {
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    phone: "الهاتف",
    address: "العنوان",
    description: "الوصف",
    status: "الحالة",
    date: "التاريخ",
    time: "الوقت",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    enabled: "مفعل",
    disabled: "معطل",
    yes: "نعم",
    no: "لا",
    all: "الكل",
    none: "لا شيء",
    select: "اختيار",
    search: "بحث",
    filter: "تصفية",
    sort: "ترتيب",
    page: "صفحة",
    of: "من",
    total: "الإجمالي",
    items: "عناصر",
    perPage: "لكل صفحة",
    showing: "عرض",
    to: "إلى",
    results: "نتائج",
  },
  placeholders: {
    search: "بحث...",
    select: "اختر خياراً...",
    enterText: "أدخل النص...",
    enterEmail: "أدخل بريدك الإلكتروني",
    enterPassword: "أدخل كلمة المرور",
    enterName: "أدخل الاسم",
    enterPhone: "أدخل رقم الهاتف",
    enterAddress: "أدخل العنوان",
    enterDescription: "أدخل الوصف...",
    noResults: "لم يتم العثور على نتائج",
  },
};
